import { render } from "./ArticleCompleted.vue?vue&type=template&id=8cfc71bc&scoped=true"
import script from "./ArticleCompleted.vue?vue&type=script&lang=js"
export * from "./ArticleCompleted.vue?vue&type=script&lang=js"

import "./ArticleCompleted.vue?vue&type=style&index=0&id=8cfc71bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cfc71bc"]])

export default __exports__